export const getTechnicalMapFilterPlaceholder = (columnHeader) =>
    `Отфильтровать по ${columnHeader}`;

export const TECHNICAL_MAP_TEXT_FILTER_FIELDS = [
    {
        id: 'typeJobName',
        label: 'Тип работы',
        placeholder: getTechnicalMapFilterPlaceholder('Тип работы'),
        sortable: true,
    },
    {
        id: 'materialName',
        label: 'Материал',
        placeholder: getTechnicalMapFilterPlaceholder('Материал'),
        sortable: true,
    },
    {
        id: 'count',
        label: 'Количество',
        placeholder: getTechnicalMapFilterPlaceholder('Количество'),
        sortable: true,
    },
    {
        id: 'unitName',
        label: 'Ед.изм.',
        placeholder: getTechnicalMapFilterPlaceholder('Ед.изм.'),
        sortable: true,
    },
    {
        id: 'normOfTime',
        label: 'НВ/ч',
        placeholder: getTechnicalMapFilterPlaceholder('НВ/ч'),
        sortable: true,
    },
    {
        id: 'jobWorkers',
        label: 'Отметки',
        placeholder: getTechnicalMapFilterPlaceholder('Отметки'),
        sortable: true,
    },
    {
        id: 'metricName',
        label: 'Описание',
        placeholder: getTechnicalMapFilterPlaceholder('Описание'),
        sortable: true,
    },
];

export const TECHNICAL_MAP_DATE_FILTER_FIELD = {
    id: 'completion',
    label: 'Дата выполнения',
    labelLines: ['Дата', 'выполнения'],
    sortable: true,
};

export const getColumnSortDirection = (sorting, columnId) => {
    if (!Array.isArray(sorting) || sorting.length === 0) {
        return null;
    }
    const entry = sorting[0];
    if (entry.id !== columnId) {
        return null;
    }
    return entry.desc ? 'desc' : 'asc';
};

export const setColumnSortDirection = (sorting, columnId, direction) => {
    const current = getColumnSortDirection(sorting, columnId);
    if (current === direction) {
        return [];
    }
    return [{id: columnId, desc: direction === 'desc'}];
};

export const getColumnFilterValue = (columnFilters, columnId) => {
    const entry = Array.isArray(columnFilters)
        ? columnFilters.find((filter) => filter.id === columnId)
        : null;
    return entry?.value ?? '';
};

export const buildColumnFilters = (draftValues) => {
    const next = [];

    TECHNICAL_MAP_TEXT_FILTER_FIELDS.forEach(({id}) => {
        const value = draftValues[id];
        if (value != null && String(value).trim() !== '') {
            next.push({id, value: String(value).trim()});
        }
    });

    const completion = draftValues.completion ?? {};
    const {startDate, endDate} = completion;
    if (startDate || endDate) {
        next.push({id: 'completion', value: {startDate, endDate}});
    }

    return next;
};

export const columnFiltersToDraft = (columnFilters) => {
    const draft = TECHNICAL_MAP_TEXT_FILTER_FIELDS.reduce((acc, {id}) => {
        acc[id] = getColumnFilterValue(columnFilters, id);
        return acc;
    }, {});

    const completionValue = getColumnFilterValue(columnFilters, 'completion');
    draft.completion = completionValue && typeof completionValue === 'object'
        ? {
            startDate: completionValue.startDate ?? null,
            endDate: completionValue.endDate ?? null,
        }
        : {startDate: null, endDate: null};

    return draft;
};
